<template>
	<Container class="py-6 lg:py-20">
		<div class="grid lg:grid-cols-2 gap-x-36 gap-y-8">
			<slot />
		</div>
	</Container>
</template>
